document.addEventListener('DOMContentLoaded', function() {
  const container = document.getElementById('evento-fields');
  const selectTipoEvento = document.getElementById('evento_tipo_evento');
  const notaFiscalSelector = document.getElementById('nota_fiscal_selector');
  const compraSelector = document.getElementById('compra_selector');

  if (!container || !selectTipoEvento) return;

  const initialDataPrevisao = container.dataset.initialDataPrevisao || "";
  const initialIndicadorQuitacao = container.dataset.initialIndicadorQuitacao || "1";
  const initialIndicadorAceitacao = container.dataset.initialIndicadorAceitacao || "";
  const initialEventoId = container.dataset.initialEventoId || "";
  const initialPerecimentoId = container.dataset.initialPerecimentoId || "";
  const itensNotaFiscalUrl = container.dataset.itensNotaFiscalUrl || "";
  const i18nPerecimento = {
    informacaoTitulo: container.dataset.i18nPerecimentoInformacaoTitulo || "",
    informacaoEvento: container.dataset.i18nPerecimentoInformacaoEvento || "",
    numeroItem: container.dataset.i18nPerecimentoNumeroItem || "",
    quantidadeAfetada: container.dataset.i18nPerecimentoQuantidadeAfetada || "",
    unidade: container.dataset.i18nPerecimentoUnidade || "",
    valorIbs: container.dataset.i18nPerecimentoValorIbs || "",
    valorCbs: container.dataset.i18nPerecimentoValorCbs || "",
    adicionarItem: container.dataset.i18nPerecimentoAdicionarItem || "",
    removerItem: container.dataset.i18nPerecimentoRemoverItem || "",
    selecioneItem: container.dataset.i18nPerecimentoSelecioneItem || "",
    selecioneNotaPrimeiro: container.dataset.i18nPerecimentoSelecioneNotaPrimeiro || ""
  };
  const i18nForm = {
    selecioneTipoEvento: container.dataset.i18nSelecioneTipoEvento || "",
    tipoEventoInvalido: container.dataset.i18nTipoEventoInvalido || ""
  };

  function parseJsonDataset(valor) {
    try {
      return JSON.parse(valor || "[]");
    } catch (erro) {
      return [];
    }
  }

  function itemPerecimentoVazio() {
    return { id: "", numeroItem: "", quantidade: "", unidade: "", valorIbs: "", valorCbs: "" };
  }

  let itensNotaFiscal = parseJsonDataset(container.dataset.itensNotaFiscal);
  let perecimentoItens = parseJsonDataset(container.dataset.initialPerecimentoItens).map(function(item) {
    return {
      id: item.id || "",
      numeroItem: item.numero_item || "",
      quantidade: item.quantidade || "",
      unidade: item.unidade || "",
      valorIbs: item.valor_ibs || "",
      valorCbs: item.valor_cbs || ""
    };
  });
  let perecimentoItensRemovidos = [];
  if (!perecimentoItens.length) perecimentoItens.push(itemPerecimentoVazio());

  function getDataPrevisaoEntregaHtml(dataValue, eventoId) {
    return `
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="control-label" for="evento_data_previsao_entrega_attributes_data_previsao_entrega">
              Data Prevista de Entrega *
            </label>            
            <div class="input-group">
              <span class="input-group-addon">
                <i class="fa fa-calendar"></i>
              </span>
              <input type="text" 
                name="fiscal_nota_fiscal_evento[data_previsao_entrega_attributes][data_previsao_entrega]" 
                id="evento_data_previsao_entrega_attributes_data_previsao_entrega" 
                class="form-control" 
                placeholder="dd/mm/aaaa" 
                required 
                value="${dataValue}">
            </div>
            ${eventoId ? `<input type="hidden" name="fiscal_nota_fiscal_evento[data_previsao_entrega_attributes][id]" value="${eventoId}">` : ''}
          </div>
        </div>
      </div>
    `;
  }

  function getPagamentoIntegralHtml(indicadorValue, eventoId) {
    return `
      <div class="row">
        <div class="col-md-12">
          <div class="alert alert-info" role="alert">
            <i class="fa fa-info-circle"></i>
            <strong>Informação sobre o evento:</strong>
            Este evento registra que houve pagamento integral efetivo da operação, conforme a Reforma Tributária (Lei Complementar nº 214/2025) e a NT 2025.002-RTC. 
            A informação é utilizada para liberar o crédito presumido do adquirente.
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="control-label">
              Indicador de Quitação *
            </label>            
            <input type="hidden" 
                   name="fiscal_nota_fiscal_evento[pagamento_integral_attributes][indicador_quitacao]" 
                   id="evento_pagamento_integral_attributes_indicador_quitacao"
                   value="${indicadorValue}">
            <p class="form-control-static">
              <strong>1 - Quitação integral confirmada</strong>
              <br>
              <small class="text-muted">
                Este valor indica que o pagamento da operação foi realizado integralmente.
              </small>
            </p>
            ${eventoId ? `<input type="hidden" name="fiscal_nota_fiscal_evento[pagamento_integral_attributes][id]" value="${eventoId}">` : ''}
          </div>
        </div>
      </div>
    `;
  }

  function getAceiteDebitoApuracaoHtml(indicadorValue, eventoId) {
    const opcao0Selecionado = indicadorValue === "0" ? 'selected="selected"' : '';
    const opcao1Selecionado = indicadorValue === "1" ? 'selected="selected"' : '';
    return `
      <div class="row">
        <div class="col-md-12">
          <div class="alert alert-info" role="alert">
            <i class="fa fa-info-circle"></i>
            <strong>Informação sobre o evento:</strong>
            Este evento registra o aceite ou não aceite dos valores de uma nota de crédito para fins de apuração de IBS/CBS, conforme a Reforma Tributária (Lei Complementar nº 214/2025) e a NT 2025.002-RTC.
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="control-label" for="evento_aceite_debito_apuracao_attributes_indicador_aceitacao">
              Indicador de Aceitação *
            </label>            
            <select name="fiscal_nota_fiscal_evento[aceite_debito_apuracao_attributes][indicador_aceitacao]"
                    id="evento_aceite_debito_apuracao_attributes_indicador_aceitacao"
                    class="form-control"
                    required>
              <option value="">Selecione</option>
              <option value="0" ${opcao0Selecionado}>0 - Não aceite</option>
              <option value="1" ${opcao1Selecionado}>1 - Aceite</option>
            </select>
            ${eventoId ? `<input type="hidden" name="fiscal_nota_fiscal_evento[aceite_debito_apuracao_attributes][id]" value="${eventoId}">` : ''}
          </div>
        </div>
      </div>
    `;
  }

  function escaparHtml(valor) {
    return String(valor || "")
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function opcoesItensNotaFiscal(numeroSelecionado) {
    const prompt = itensNotaFiscal.length ? i18nPerecimento.selecioneItem : i18nPerecimento.selecioneNotaPrimeiro;
    const opcoes = itensNotaFiscal.map(function(itemNota) {
      const selecionado = String(itemNota.numero_item) === String(numeroSelecionado) ? 'selected="selected"' : '';
      const rotulo = `${itemNota.numero_item} - ${itemNota.codigo || ''} - ${itemNota.descricao || ''}`;
      return `<option value="${itemNota.numero_item}" data-unidade="${escaparHtml(itemNota.unidade)}" ${selecionado}>${escaparHtml(rotulo)}</option>`;
    }).join('');
    return `<option value="">${escaparHtml(prompt)}</option>${opcoes}`;
  }

  function getPerecimentoItemHtml(item, indice) {
    const idHidden = item.id
      ? `<input type="hidden" name="fiscal_nota_fiscal_evento[perecimento_attributes][itens_attributes][${indice}][id]" value="${escaparHtml(item.id)}">`
      : '';
    return `
      <div class="form-row perecimento-item">
        <div class="form-group col-md-4">
          <label class="control-label required" for="evento_perecimento_attributes_itens_attributes_${indice}_numero_item">
            ${i18nPerecimento.numeroItem} *
          </label>
          <select name="fiscal_nota_fiscal_evento[perecimento_attributes][itens_attributes][${indice}][numero_item]"
                  id="evento_perecimento_attributes_itens_attributes_${indice}_numero_item"
                  class="form-control perecimento-numero-item"
                  required>
            ${opcoesItensNotaFiscal(item.numeroItem)}
          </select>
        </div>
        <div class="form-group col-md-2">
          <label class="control-label required" for="evento_perecimento_attributes_itens_attributes_${indice}_quantidade_perecimento">
            ${i18nPerecimento.quantidadeAfetada} *
          </label>
          <input type="number"
                 name="fiscal_nota_fiscal_evento[perecimento_attributes][itens_attributes][${indice}][quantidade_perecimento]"
                 id="evento_perecimento_attributes_itens_attributes_${indice}_quantidade_perecimento"
                 class="form-control perecimento-quantidade"
                 step="0.0001"
                 min="0.0001"
                 required
                 value="${escaparHtml(item.quantidade)}">
        </div>
        <div class="form-group col-md-1">
          <label class="control-label required" for="evento_perecimento_attributes_itens_attributes_${indice}_unidade_perecimento">
            ${i18nPerecimento.unidade} *
          </label>
          <input type="text"
                 name="fiscal_nota_fiscal_evento[perecimento_attributes][itens_attributes][${indice}][unidade_perecimento]"
                 id="evento_perecimento_attributes_itens_attributes_${indice}_unidade_perecimento"
                 class="form-control perecimento-unidade"
                 maxlength="6"
                 required
                 value="${escaparHtml(item.unidade)}">
        </div>
        <div class="form-group col-md-2">
          <label class="control-label required" for="evento_perecimento_attributes_itens_attributes_${indice}_valor_ibs">
            ${i18nPerecimento.valorIbs} *
          </label>
          <input type="number"
                 name="fiscal_nota_fiscal_evento[perecimento_attributes][itens_attributes][${indice}][valor_ibs]"
                 id="evento_perecimento_attributes_itens_attributes_${indice}_valor_ibs"
                 class="form-control text-right perecimento-valor-ibs"
                 step="0.01"
                 min="0"
                 required
                 value="${escaparHtml(item.valorIbs)}">
        </div>
        <div class="form-group col-md-2">
          <label class="control-label required" for="evento_perecimento_attributes_itens_attributes_${indice}_valor_cbs">
            ${i18nPerecimento.valorCbs} *
          </label>
          <input type="number"
                 name="fiscal_nota_fiscal_evento[perecimento_attributes][itens_attributes][${indice}][valor_cbs]"
                 id="evento_perecimento_attributes_itens_attributes_${indice}_valor_cbs"
                 class="form-control text-right perecimento-valor-cbs"
                 step="0.01"
                 min="0"
                 required
                 value="${escaparHtml(item.valorCbs)}">
        </div>
        <div class="form-group col-md-1">
          <label class="control-label">&nbsp;</label>
          <button type="button"
                  class="btn btn-danger btn-block perecimento-remover-item"
                  title="${escaparHtml(i18nPerecimento.removerItem)}">
            <i class="fa fa-trash"></i>
          </button>
        </div>
        ${idHidden}
      </div>
    `;
  }

  function getPerecimentoHtml() {
    const linhas = perecimentoItens.map(getPerecimentoItemHtml).join('');
    const removidos = perecimentoItensRemovidos.map(function(itemId, posicao) {
      const indice = 9000 + posicao;
      return `
        <input type="hidden" name="fiscal_nota_fiscal_evento[perecimento_attributes][itens_attributes][${indice}][id]" value="${escaparHtml(itemId)}">
        <input type="hidden" name="fiscal_nota_fiscal_evento[perecimento_attributes][itens_attributes][${indice}][_destroy]" value="1">
      `;
    }).join('');
    const perecimentoIdHidden = initialPerecimentoId
      ? `<input type="hidden" name="fiscal_nota_fiscal_evento[perecimento_attributes][id]" value="${escaparHtml(initialPerecimentoId)}">`
      : '';
    return `
      <div class="row">
        <div class="col-md-12">
          <div class="alert alert-info" role="alert">
            <i class="fa fa-info-circle"></i>
            <strong>${i18nPerecimento.informacaoTitulo}</strong>
            ${i18nPerecimento.informacaoEvento}
          </div>
        </div>
      </div>
      <div id="perecimento-itens">${linhas}</div>
      <div class="form-row">
        <div class="form-group col-md-3">
          <button type="button" class="btn btn-default" id="perecimento-adicionar-item">
            <i class="fa fa-plus"></i> ${escaparHtml(i18nPerecimento.adicionarItem)}
          </button>
        </div>
      </div>
      ${removidos}
      ${perecimentoIdHidden}
    `;
  }

  function lerPerecimentoItensDoDom() {
    const linhas = container.querySelectorAll('.perecimento-item');
    if (!linhas.length) return;
    perecimentoItens = Array.from(linhas).map(function(linha) {
      const idHidden = linha.querySelector('input[name$="[id]"]');
      return {
        id: idHidden ? idHidden.value : "",
        numeroItem: linha.querySelector('.perecimento-numero-item').value,
        quantidade: linha.querySelector('.perecimento-quantidade').value,
        unidade: linha.querySelector('.perecimento-unidade').value,
        valorIbs: linha.querySelector('.perecimento-valor-ibs').value,
        valorCbs: linha.querySelector('.perecimento-valor-cbs').value
      };
    });
  }

  function renderPerecimento() {
    if (selectTipoEvento.value !== 'Fiscal::NotaFiscal::Evento::Perecimento') return;
    container.innerHTML = getPerecimentoHtml();
  }

  function resetPerecimentoItens() {
    perecimentoItens.forEach(function(item) {
      if (item.id) perecimentoItensRemovidos.push(item.id);
    });
    perecimentoItens = [itemPerecimentoVazio()];
  }

  function aoTrocarNotaFiscal(notaFiscalId) {
    if (!itensNotaFiscalUrl || !notaFiscalId) {
      itensNotaFiscal = [];
      resetPerecimentoItens();
      renderPerecimento();
      return;
    }
    fetch(`${itensNotaFiscalUrl}?nota_fiscal_id=${encodeURIComponent(notaFiscalId)}`, { headers: { 'Accept': 'application/json' } })
      .then(function(resposta) { return resposta.ok ? resposta.json() : []; })
      .then(function(itens) {
        itensNotaFiscal = itens;
        resetPerecimentoItens();
        renderPerecimento();
      })
      .catch(function() {
        itensNotaFiscal = [];
        resetPerecimentoItens();
        renderPerecimento();
      });
  }

  container.addEventListener('click', function(evento) {
    if (evento.target.closest('#perecimento-adicionar-item')) {
      lerPerecimentoItensDoDom();
      perecimentoItens.push(itemPerecimentoVazio());
      renderPerecimento();
      return;
    }
    const botaoRemover = evento.target.closest('.perecimento-remover-item');
    if (!botaoRemover) return;
    lerPerecimentoItensDoDom();
    const linhas = Array.from(container.querySelectorAll('.perecimento-item'));
    const indice = linhas.indexOf(botaoRemover.closest('.perecimento-item'));
    const item = perecimentoItens[indice];
    if (item && item.id) perecimentoItensRemovidos.push(item.id);
    perecimentoItens.splice(indice, 1);
    if (!perecimentoItens.length) perecimentoItens.push(itemPerecimentoVazio());
    renderPerecimento();
  });

  container.addEventListener('change', function(evento) {
    if (!evento.target.classList.contains('perecimento-numero-item')) return;
    const opcao = evento.target.selectedOptions[0];
    const linha = evento.target.closest('.perecimento-item');
    const unidadeInput = linha && linha.querySelector('.perecimento-unidade');
    if (opcao && opcao.dataset.unidade && unidadeInput) unidadeInput.value = opcao.dataset.unidade;
  });

  const notaFiscalSelect = document.getElementById('evento_nota_fiscal_id');
  if (notaFiscalSelect) {
    const aoMudarNota = function() { aoTrocarNotaFiscal(notaFiscalSelect.value); };
    if (window.jQuery) {
      window.jQuery(notaFiscalSelect).on('change', aoMudarNota);
    } else {
      notaFiscalSelect.addEventListener('change', aoMudarNota);
    }
  }

  function updateDocumentSelectorVisibility(tipoEvento) {
    if (!notaFiscalSelector || !compraSelector) return;

    if (!tipoEvento) {
      notaFiscalSelector.style.display = 'none';
      compraSelector.style.display = 'none';
    } else if (tipoEvento === 'Fiscal::NotaFiscal::Evento::AceiteDebitoApuracao') {
      notaFiscalSelector.style.display = 'none';
      compraSelector.style.display = 'block';
    } else {
      notaFiscalSelector.style.display = 'block';
      compraSelector.style.display = 'none';
    }
  }

  function renderEventoFields(tipoEvento) {
    if (!tipoEvento) {
      container.innerHTML = `<div class="alert alert-info">${escaparHtml(i18nForm.selecioneTipoEvento)}</div>`;
      updateDocumentSelectorVisibility(tipoEvento);
      return;
    }

    switch(tipoEvento) {
      case 'Fiscal::NotaFiscal::Evento::DataPrevisaoEntrega':
        container.innerHTML = getDataPrevisaoEntregaHtml(initialDataPrevisao, initialEventoId);
        break;
      case 'Fiscal::NotaFiscal::Evento::PagamentoIntegral':
        container.innerHTML = getPagamentoIntegralHtml(initialIndicadorQuitacao, initialEventoId);
        break;
      case 'Fiscal::NotaFiscal::Evento::AceiteDebitoApuracao':
        container.innerHTML = getAceiteDebitoApuracaoHtml(initialIndicadorAceitacao, initialEventoId);
        break;
      case 'Fiscal::NotaFiscal::Evento::Perecimento':
        container.innerHTML = getPerecimentoHtml();
        break;
      default:
        container.innerHTML = `<div class="alert alert-info">${escaparHtml(i18nForm.tipoEventoInvalido)}</div>`;
    }
    updateDocumentSelectorVisibility(tipoEvento);
  }

  selectTipoEvento.addEventListener('change', function() {
    renderEventoFields(this.value);
  });

  const tipoEventoInicial = selectTipoEvento.value;
  if (tipoEventoInicial) {
    renderEventoFields(tipoEventoInicial);
  }
});
